import Tippy from "@tippyjs/react";
import styled from "styled-components";

import "tippy.js/dist/tippy.css";

const Tooltip = styled(Tippy)`
  && {
    padding: 6px 8px;
    background-color: var(--color-ds-neutral-12);
    color: var(--color-ds-text-inverse);
    filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.18));

    .tippy-arrow {
      color: var(--color-ds-neutral-12);
    }
  }
`;

export default Tooltip;
